import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref, computed as _computed } from 'vue';

// eslint-disable-next-line
// @ts-nocheck
import {
  Vue,
} from 'vue-property-decorator';
import { onBeforeUnmount, onMounted, watch } from 'vue';
import src from '@/utils/filters/src';
import { isSourceBeta } from '@/utils/betaComparator';
import type { QueryType } from '@/utils/query';
import IncidentStatus from '@/components/incidents/Incident-Status.vue';
import SAvatars from '@/components/SAvatars/SAvatars.vue';

type Child = {
  name: string;
  id: string;
  results: number;
  children: Child[];
}

type MultiCheckboxDescriptor = {
  name: string;
  query: string;
  children: Child[];
}

type TreeCheckboxSelectorEmits = {
  (event: 'input', filter: { [key: string]: QueryType | number }): void
}

interface TreeCheckboxSelectProps {
  filter?: MultiCheckboxDescriptor,
  hasSearch?: boolean
  expandable?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Tree-Checkbox-Selector',
  props: {
  filter: { default: () => ({
    name: '',
    query: '',
    children: [],
  }) },
  hasSearch: { type: Boolean, default: false },
  expandable: { type: Boolean, default: true }
},
  emits: ["input"],
  setup(__props, { emit }) {

const props = __props;




const treeview = _ref<HTMLElement>();
const selection = _ref([]);
const search = _ref('');

const items = _computed(() => props.filter?.children);
const name = _computed(() => props.filter?.name);
const isCriticality = _computed(() => props.filter?.query === 'criticality');
const isStatus = _computed(() => props.filter?.query === 'status');
const isUsage = _computed(() => props.filter?.query === 'usage');
const isOwner = _computed(() => props.filter?.query === 'assignment');
const isTeam = _computed(() => props.filter?.query === 'team');
const hasResults = _computed(() => !!items.value?.length);

const isBeta = (sourceType: string) => isSourceBeta(sourceType);
const hasIcon = (item: Child) => props.filter?.query === 'datasources' && 'children' in item;
const getImage = (id: string) => src(id, 'datasources');

const usageIcon = (usage: string) => {
  switch (usage.toLowerCase()) {
    case 'high':
      return 'icon-usage-high';
    case 'medium':
      return 'icon-usage-mid';
    case 'low':
      return 'icon-usage-low';
    case 'not available':
      return '';
    default:
      return null;
  }
};

const criticalityId = (criticality: string) => {
  switch (criticality.toLowerCase()) {
    case 'critical':
      return 0;
    case 'high':
      return 1;
    case 'moderate':
      return 2;
    case 'low':
      return 3;
    default:
      return null;
  }
};

const removeWrap = (e: MouseEvent) => {
  const target = e.target as HTMLElement;
  if (target.className === 'v-treeview-node__root') {
    target
      .querySelector('.v-treeview-node__content > *')!
      .classList.add('remove-wrap');
  }
};

const addWrap = (e: MouseEvent) => {
  const target = e.target as HTMLElement;
  if (target.className === 'v-treeview-node__root') {
    target
      .querySelector('.v-treeview-node__content > *')!
      .classList.remove('remove-wrap');
  }
};

onMounted(() => {
  Vue.nextTick(() => {
    if (!treeview.value) return;
    treeview.value.$el.addEventListener('mouseenter', removeWrap, true);
    treeview.value.$el.addEventListener('mouseleave', addWrap, true);
  });
});

onBeforeUnmount(() => {
  if (treeview.value && treeview.value.$el) {
    treeview.value.$el.removeEventListener('mouseenter', removeWrap);
    treeview.value.$el.removeEventListener('mouseleave', addWrap);
  }
});

watch(() => selection.value, () => {
  emit('input', { [props.filter.query]: selection.value });
});

return { __sfc: true,props, emit, treeview, selection, search, items, name, isCriticality, isStatus, isUsage, isOwner, isTeam, hasResults, isBeta, hasIcon, getImage, usageIcon, criticalityId, removeWrap, addWrap, _ref, _computed, Vue, onBeforeUnmount, onMounted, watch, src, isSourceBeta, IncidentStatus, SAvatars }
}

})